import { FULLLINK } from './constants';

export const withFulllink = (editor) => {
  const { isInline } = editor;

  editor.isInline = (element) => {
    return element && element.type === FULLLINK ? true : isInline(element);
  };

  return editor;
};
